import React from 'react';
import './index.scss';
import { CircleLabelList, IProps as ICircleProps} from './circleLabel';
interface IProps extends ICircleProps{
  isShowTitle?: boolean;
  title?: string | JSX.Element;
}
const ChartTooltip = (props: IProps) => {
  const { title = '' ,isShowTitle, ...res } = props;
  return (
    <div className={`tooltip-custom-chart-info  ${res.className}-custom`}>
      {isShowTitle && <div className='chart-title' title={title as string}>{title}</div>}
      <CircleLabelList className='chart-legend' {...res} />
    </div>
  );
}
export {
    ChartTooltip
}
